var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 57 55",
    width: 57,
    height: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.84 49.88C16.74 48.88 8.52 39.88 8.52 28.69C8.52 20.3 13.4 12.74 20.73 9.24C20.62 9.02 20.58 8.77 20.63 8.53C12.87 12.11 7.46 20.08 7.46 28.81C7.46 40.36 16.02 49.91 27.46 50.94C27.46 50.94 31.87 51.16 33.06 53.44C33.11 53.53 34.84 53.51 34.91 53.45C35.05 53.32 35.02 53.13 34.92 52.97C33.65 50.75 29.25 50.49 27.84 49.88Z",
    id: "bp6CyIh8O"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9 11.57C13.05 12.71 12.49 13.58 12.15 13.91C11.75 13.68 10.98 12.99 10.83 11.85C10.66 10.61 11.05 9.38 11.43 8.54C11.43 8.54 11.43 8.54 11.43 8.54C12.3 9.74 12.79 10.75 12.9 11.57ZM9.84 11.98C10.1 13.96 11.74 14.99 12.26 14.99C12.27 14.99 12.29 14.99 12.3 14.99C12.77 14.92 14.16 13.47 13.89 11.44C13.53 8.79 11.21 6.88 11.21 6.88C11.21 6.88 11.21 6.88 11.21 6.88C10.06 8.51 9.6 10.22 9.84 11.98Z",
    id: "a1t6uPoYZp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.21 8.43C17.84 9.16 17.21 9.45 16.83 9.55C16.7 9.18 16.6 8.48 16.96 7.78C17.38 6.99 18.07 6.41 18.67 6.03C18.67 6.03 18.67 6.03 18.67 6.03C18.64 7.11 18.49 7.91 18.21 8.43ZM16.08 7.32C15.29 8.83 15.97 10.36 16.31 10.55C16.37 10.58 16.46 10.59 16.58 10.59C17.18 10.59 18.44 10.16 19.1 8.89C20.13 6.92 19.47 4.5 19.47 4.5C19.47 4.5 19.47 4.5 19.47 4.5C17.9 5.06 16.77 6 16.08 7.32Z",
    id: "a1HpNsIBlr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.58 7.57C24.09 7.57 24.56 7.65 24.97 7.75C24.47 8.26 23.76 8.82 22.91 9.06C22.71 9.12 22.5 9.15 22.3 9.15C21.8 9.15 21.39 8.97 21.15 8.82C21.32 8.48 21.76 7.92 22.52 7.71C22.85 7.61 23.21 7.57 23.58 7.57C23.58 7.57 23.58 7.57 23.58 7.57C23.58 7.57 23.58 7.57 23.58 7.57ZM22.25 6.74C20.61 7.2 19.96 8.75 20.06 9.13C20.15 9.44 21.07 10.15 22.3 10.15C22.58 10.15 22.87 10.11 23.18 10.02C25.32 9.42 26.63 7.28 26.63 7.28C26.63 7.28 25.23 6.57 23.58 6.57C23.58 6.57 23.58 6.57 23.58 6.57C22.99 6.6 22.55 6.66 22.25 6.74Z",
    id: "c8QogCGmx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.49 11.54C18.54 11.54 18.6 11.54 18.65 11.55C19.54 11.61 20.35 12.02 20.94 12.42C20.36 12.7 19.6 12.96 18.8 12.96C18.72 12.96 18.63 12.96 18.55 12.95C17.76 12.89 17.22 12.44 16.97 12.13C17.24 11.88 17.77 11.54 18.49 11.54C18.49 11.54 18.49 11.54 18.49 11.54C18.49 11.54 18.49 11.54 18.49 11.54ZM15.85 12.05C15.83 12.44 16.78 13.83 18.48 13.95C18.59 13.96 18.69 13.96 18.8 13.96C20.89 13.96 22.66 12.55 22.66 12.55C22.66 12.55 20.95 10.71 18.73 10.55C18.65 10.54 18.57 10.54 18.49 10.54C18.49 10.54 18.49 10.54 18.49 10.54C16.75 11.3 15.87 11.8 15.85 12.05Z",
    id: "aWxmOQu9S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.91 25.19C11.15 25.9 10.27 25.98 9.92 25.98C9.78 25.98 9.67 25.97 9.58 25.96C9.53 25.49 9.63 24.46 10.47 23.67C11.38 22.81 12.6 22.41 13.51 22.22C13.51 22.22 13.51 22.22 13.51 22.22C13.05 23.62 12.51 24.61 11.91 25.19ZM9.78 22.95C8.3 24.36 8.47 26.36 8.79 26.71C8.93 26.85 9.36 26.98 9.92 26.98C10.7 26.98 11.74 26.73 12.6 25.91C14.54 24.07 14.72 21.07 14.72 21.07C14.72 21.07 14.72 21.07 14.72 21.07C12.72 21.09 11.07 21.72 9.78 22.95Z",
    id: "d5CI84F09G"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.39 16.14C16.86 16.89 16 17.85 14.84 18.34C14.49 18.48 14.12 18.56 13.74 18.56C13.13 18.56 12.64 18.37 12.39 18.23C12.51 17.77 12.98 16.85 14.04 16.41C14.64 16.16 15.33 16.03 16.1 16.03C16.1 16.03 16.1 16.03 16.1 16.03C16.71 16.06 17.14 16.1 17.39 16.14ZM13.65 15.49C11.76 16.27 11.21 18.21 11.39 18.64C11.52 18.96 12.49 19.56 13.74 19.56C14.2 19.56 14.71 19.47 15.23 19.26C17.69 18.23 18.94 15.49 18.94 15.49C18.94 15.49 17.68 15.03 16.1 15.03C16.1 15.03 16.1 15.03 16.1 15.03C15.01 15.1 14.2 15.26 13.65 15.49Z",
    id: "e1KSmX5ANM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.01 31.94C11.39 32.88 10.43 33.18 9.92 33.22C9.76 32.77 9.63 31.75 10.26 30.79C10.95 29.74 12.05 29.07 12.89 28.69C12.89 28.69 12.89 28.69 12.89 28.69C12.77 30.15 12.47 31.24 12.01 31.94ZM9.42 30.24C8.3 31.95 8.93 33.87 9.32 34.13C9.41 34.18 9.58 34.22 9.81 34.22C10.58 34.22 11.98 33.81 12.85 32.49C14.31 30.25 13.81 27.28 13.81 27.28C13.81 27.28 13.81 27.28 13.81 27.28C11.87 27.76 10.41 28.75 9.42 30.24Z",
    id: "a4bZct5Az"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73 40.99C8.97 40.99 9.21 41.01 9.43 41.04C10.93 41.23 11.79 42.3 12.03 42.77C11.72 43.12 10.82 43.82 9.54 43.82C9.39 43.82 9.23 43.81 9.08 43.79C7.47 43.58 6.09 42.61 5.25 41.89C6.1 41.47 7.37 40.99 8.73 40.99C8.73 40.99 8.73 40.99 8.73 40.99C8.73 40.99 8.73 40.99 8.73 40.99ZM3.62 41.68C3.62 41.68 5.85 44.38 8.95 44.78C9.15 44.81 9.35 44.82 9.54 44.82C11.59 44.82 13.01 43.41 13.08 42.91C13.15 42.37 11.93 40.36 9.56 40.05C9.28 40.01 9.01 39.99 8.73 39.99C8.73 39.99 8.73 39.99 8.73 39.99C6 40.89 4.3 41.45 3.62 41.68Z",
    id: "b1jb0U2SW9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 38.32C14.55 39.58 13.28 40.04 12.68 40.08C12.44 39.61 12.1 38.29 12.83 36.97C13.61 35.55 15.02 34.62 16 34.11C16 34.11 16 34.11 16 34.11C16.03 35.97 15.78 37.37 15.25 38.32ZM11.95 36.48C10.8 38.57 11.68 40.75 12.17 41.01C12.25 41.06 12.4 41.09 12.58 41.09C13.44 41.09 15.17 40.52 16.12 38.8C17.64 36.07 16.8 32.67 16.8 32.67C16.8 32.67 16.8 32.67 16.8 32.67C14.58 33.39 12.96 34.66 11.95 36.48Z",
    id: "e1INFPZBV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09 31.83C3.09 31.83 4.53 31.98 5.75 32.7C7.05 33.47 7.42 34.79 7.45 35.32C7.22 35.43 6.75 35.58 6.14 35.58C5.5 35.58 4.89 35.42 4.34 35.09C2.94 34.27 2.05 32.84 1.57 31.85C1.73 31.84 1.91 31.83 2.09 31.83C2.09 31.83 2.09 31.83 2.09 31.83C2.09 31.83 2.09 31.83 2.09 31.83ZM0.15 31.01C0.15 31.01 1.14 34.37 3.83 35.95C4.62 36.42 5.42 36.58 6.14 36.58C7.29 36.58 8.19 36.15 8.37 35.86C8.65 35.38 8.32 33.06 6.26 31.84C4.88 31.03 3.3 30.83 2.09 30.83C2.09 30.83 2.09 30.83 2.09 30.83C1.06 30.92 0.41 30.98 0.15 31.01Z",
    id: "b32yhIGDwF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.21 43.31C19.56 44.59 18.34 45.09 17.71 45.17C17.44 44.71 17.05 43.4 17.73 42.06C18.46 40.61 19.82 39.63 20.79 39.07C20.79 39.07 20.79 39.07 20.79 39.07C20.89 40.93 20.69 42.34 20.21 43.31ZM16.84 41.61C15.76 43.74 16.74 45.87 17.23 46.12C17.31 46.16 17.43 46.18 17.58 46.18C18.4 46.18 20.19 45.56 21.1 43.76C22.51 40.97 21.53 37.6 21.53 37.6C21.53 37.6 21.53 37.6 21.53 37.6C19.34 38.41 17.77 39.75 16.84 41.61Z",
    id: "c2EWHgLUjo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91 24.35C6.89 25.49 6.83 26.86 6.69 27.37C6.62 27.38 6.53 27.39 6.42 27.39C6.06 27.39 4.79 27.3 3.81 26.17C2.75 24.94 2.35 23.31 2.21 22.21C2.21 22.21 2.21 22.21 2.21 22.21C3.96 22.82 5.2 23.53 5.91 24.35ZM3.05 26.83C4.1 28.03 5.49 28.39 6.42 28.39C6.89 28.39 7.25 28.3 7.39 28.17C7.8 27.81 8.22 25.5 6.66 23.7C4.62 21.34 1.13 20.96 1.13 20.96C1.13 20.96 1.13 20.96 1.13 20.96C1.05 23.3 1.69 25.25 3.05 26.83Z",
    id: "bwouNWDPb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.77 47.53C16.96 47.53 17.83 48.14 18.13 48.46C17.93 48.94 17.12 50.05 15.63 50.31C15.32 50.37 14.98 50.4 14.64 50.4C13.39 50.4 12.22 50.02 11.41 49.67C12.21 48.9 13.54 47.88 15.14 47.59C15.35 47.55 15.56 47.53 15.77 47.53C15.77 47.53 15.77 47.53 15.77 47.53C15.77 47.53 15.77 47.53 15.77 47.53ZM14.97 46.6C11.89 47.15 9.79 49.96 9.79 49.96C9.79 49.96 12.03 51.4 14.64 51.4C15.03 51.4 15.42 51.37 15.81 51.3C18.16 50.88 19.27 48.81 19.18 48.27C19.09 47.79 17.7 46.53 15.77 46.53C15.77 46.53 15.77 46.53 15.77 46.53C15.42 46.54 15.15 46.57 14.97 46.6Z",
    id: "a1R6To3G2P"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62 16.71C9.19 18.11 8.69 19.38 8.39 19.82C7.87 19.72 6.62 19.17 6.05 17.76C5.43 16.26 5.59 14.58 5.8 13.49C5.8 13.49 5.8 13.49 5.8 13.49C7.26 14.63 8.2 15.7 8.62 16.71ZM5.12 18.14C5.92 20.1 7.78 20.84 8.55 20.84C8.65 20.84 8.73 20.83 8.79 20.81C9.3 20.59 10.44 18.54 9.54 16.33C8.36 13.44 5.18 11.97 5.18 11.97C5.18 11.97 5.18 11.97 5.18 11.97C4.35 14.16 4.34 16.21 5.12 18.14Z",
    id: "d3g3U5zcE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.23 9.15C42.67 12.6 47.63 20.23 47.63 28.69C47.63 39.88 39.41 48.88 28.31 49.88C28.31 49.88 22.5 50.75 21.23 52.97C21.13 53.13 21.1 53.32 21.24 53.45C21.3 53.51 23.04 53.53 23.08 53.44C24.28 51.16 28.69 50.94 28.69 50.94C40.13 49.91 48.69 40.36 48.69 28.81C48.69 20.07 43.28 12.1 35.51 8.52C35.49 8.75 35.4 8.97 35.23 9.15Z",
    id: "a2VQuQsrXC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.32 11.85C45.17 12.99 44.4 13.68 43.99 13.91C43.66 13.58 43.1 12.71 43.25 11.58C43.42 10.33 44.12 9.25 44.71 8.54C44.71 8.54 44.71 8.54 44.71 8.54C45.23 9.92 45.43 11.03 45.32 11.85ZM42.26 11.44C41.99 13.47 43.38 14.92 43.85 14.99C43.86 14.99 43.88 14.99 43.89 14.99C44.41 14.99 46.05 13.96 46.31 11.98C46.67 9.33 44.94 6.88 44.94 6.88C44.94 6.88 44.94 6.88 44.94 6.88C43.39 8.15 42.5 9.67 42.26 11.44Z",
    id: "ajw7r3pRZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.19 7.78C39.55 8.48 39.45 9.18 39.32 9.55C38.95 9.45 38.31 9.16 37.94 8.43C37.52 7.64 37.45 6.74 37.48 6.03C37.48 6.03 37.48 6.03 37.48 6.03C38.34 6.67 38.91 7.25 39.19 7.78ZM37.05 8.89C37.71 10.16 38.97 10.59 39.57 10.59C39.69 10.59 39.78 10.57 39.84 10.55C40.18 10.36 40.86 8.83 40.07 7.32C39.04 5.34 36.68 4.5 36.68 4.5C36.68 4.5 36.68 4.5 36.68 4.5C36.24 6.11 36.36 7.58 37.05 8.89Z",
    id: "a1yhz4Alp9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.63 7.71C34.39 7.92 34.82 8.48 35 8.82C34.76 8.97 34.35 9.15 33.85 9.15C33.65 9.15 33.44 9.12 33.24 9.06C32.39 8.82 31.68 8.26 31.18 7.75C31.58 7.65 32.06 7.57 32.56 7.57C32.56 7.57 32.56 7.57 32.56 7.57C33.05 7.6 33.41 7.64 33.63 7.71ZM29.52 7.28C29.52 7.28 30.83 9.42 32.97 10.02C33.28 10.11 33.57 10.15 33.85 10.15C35.08 10.15 35.99 9.44 36.08 9.13C36.19 8.75 35.54 7.2 33.9 6.74C33.45 6.62 33 6.57 32.56 6.57C32.56 6.57 32.56 6.57 32.56 6.57C30.94 6.95 29.92 7.19 29.52 7.28Z",
    id: "aG0eA6I85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.17 12.13C38.93 12.44 38.39 12.89 37.6 12.95C37.51 12.96 37.43 12.96 37.35 12.96C36.55 12.96 35.79 12.7 35.21 12.42C35.8 12.02 36.61 11.61 37.49 11.55C37.55 11.54 37.61 11.54 37.66 11.54C37.66 11.54 37.66 11.54 37.66 11.54C38.49 11.77 39 11.97 39.17 12.13ZM37.42 10.55C35.2 10.71 33.49 12.55 33.49 12.55C33.49 12.55 35.26 13.96 37.35 13.96C37.45 13.96 37.56 13.96 37.67 13.95C39.37 13.83 40.32 12.44 40.29 12.05C40.27 11.68 39.23 10.54 37.66 10.54C37.66 10.54 37.66 10.54 37.66 10.54C37.56 10.54 37.48 10.55 37.42 10.55Z",
    id: "amLRMYUvB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.68 23.67C46.52 24.46 46.62 25.49 46.57 25.96C46.48 25.97 46.37 25.98 46.23 25.98C45.88 25.98 45 25.9 44.24 25.19C43.33 24.32 42.87 23.12 42.64 22.23C42.64 22.23 42.64 22.23 42.64 22.23C44.07 22.61 45.08 23.1 45.68 23.67ZM43.55 25.91C44.41 26.73 45.45 26.98 46.23 26.98C46.79 26.98 47.22 26.85 47.36 26.71C47.68 26.36 47.85 24.36 46.37 22.95C44.44 21.1 41.43 21.07 41.43 21.07C41.43 21.07 41.43 21.07 41.43 21.07C41.55 23.07 42.26 24.68 43.55 25.91Z",
    id: "cc9rhfnp4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.11 16.41C43.17 16.85 43.64 17.77 43.76 18.23C43.5 18.37 43.02 18.56 42.41 18.56C42.03 18.56 41.66 18.48 41.31 18.34C40.15 17.85 39.29 16.89 38.76 16.14C39.13 16.08 39.57 16.03 40.04 16.03C40.04 16.03 40.04 16.03 40.04 16.03C41.02 16.11 41.71 16.24 42.11 16.41ZM37.21 15.49C37.21 15.49 38.46 18.23 40.92 19.26C41.44 19.47 41.94 19.56 42.41 19.56C43.66 19.56 44.63 18.96 44.76 18.64C44.94 18.21 44.39 16.27 42.5 15.48C41.68 15.14 40.82 15.03 40.04 15.03C40.04 15.03 40.04 15.03 40.04 15.03C38.53 15.28 37.59 15.43 37.21 15.49Z",
    id: "b2vhuE3Ur"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.89 30.79C46.52 31.75 46.38 32.77 46.23 33.22C45.72 33.18 44.76 32.88 44.14 31.94C43.45 30.89 43.27 29.61 43.26 28.69C43.26 28.69 43.26 28.69 43.26 28.69C44.55 29.39 45.43 30.09 45.89 30.79ZM43.3 32.48C44.17 33.81 45.57 34.22 46.34 34.22C46.56 34.22 46.74 34.18 46.83 34.13C47.22 33.87 47.84 31.95 46.72 30.24C45.25 28.01 42.34 27.28 42.34 27.28C42.34 27.28 42.34 27.28 42.34 27.28C42 29.26 42.32 30.99 43.3 32.48Z",
    id: "a1sSjBZwo6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9 41.89C50.07 42.62 48.69 43.58 47.07 43.79C46.92 43.81 46.76 43.82 46.61 43.82C45.33 43.82 44.43 43.13 44.12 42.77C44.36 42.3 45.22 41.23 46.72 41.04C46.94 41.01 47.18 40.99 47.42 40.99C47.42 40.99 47.42 40.99 47.42 40.99C49.17 41.31 50.33 41.61 50.9 41.89ZM46.59 40.05C44.22 40.36 43 42.36 43.07 42.91C43.14 43.41 44.56 44.82 46.61 44.82C46.8 44.82 47 44.81 47.2 44.78C50.29 44.38 52.53 41.68 52.53 41.68C52.53 41.68 50.17 39.99 47.42 39.99C47.42 39.99 47.42 39.99 47.42 39.99C47.05 40 46.77 40.02 46.59 40.05Z",
    id: "dtSmeDUrz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.32 36.97C44.05 38.29 43.71 39.61 43.47 40.08C42.87 40.04 41.6 39.58 40.9 38.31C40.11 36.89 40.06 35.21 40.15 34.1C40.15 34.1 40.15 34.1 40.15 34.1C41.74 35.06 42.79 36.01 43.32 36.97ZM40.03 38.8C40.98 40.52 42.71 41.09 43.57 41.09C43.75 41.09 43.9 41.06 43.98 41.01C44.46 40.75 45.35 38.57 44.2 36.48C42.68 33.75 39.35 32.67 39.35 32.67C39.35 32.67 39.35 32.67 39.35 32.67C38.79 34.94 39.01 36.98 40.03 38.8Z",
    id: "b2gHgwKXbZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.59 31.84C54.11 32.84 53.22 34.26 51.81 35.09C51.26 35.42 50.65 35.58 50.01 35.58C49.4 35.58 48.93 35.43 48.7 35.32C48.72 34.79 49.1 33.47 50.4 32.7C51.62 31.98 53.06 31.83 54.05 31.83C54.05 31.83 54.05 31.83 54.05 31.83C54.3 31.83 54.48 31.84 54.59 31.84ZM49.89 31.84C47.83 33.06 47.5 35.38 47.78 35.86C47.96 36.15 48.86 36.58 50.01 36.58C50.73 36.58 51.53 36.42 52.32 35.95C55.01 34.37 56 31.01 56 31.01C56 31.01 55.19 30.83 54.05 30.83C54.05 30.83 54.05 30.83 54.05 30.83C52.2 30.96 50.81 31.3 49.89 31.84Z",
    id: "a1477dlS4K"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.42 42.06C39.1 43.41 38.7 44.72 38.44 45.18C37.84 45.11 36.6 44.61 35.94 43.31C35.21 41.86 35.23 40.18 35.36 39.08C35.36 39.08 35.36 39.08 35.36 39.08C36.91 40.1 37.93 41.09 38.42 42.06ZM35.05 43.76C35.96 45.56 37.75 46.18 38.57 46.18C38.72 46.18 38.84 46.16 38.92 46.12C39.41 45.87 40.39 43.74 39.31 41.61C37.91 38.82 34.62 37.6 34.62 37.6C34.62 37.6 34.62 37.6 34.62 37.6C33.97 39.85 34.11 41.9 35.05 43.76Z",
    id: "j229IrWkF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.34 26.17C51.36 27.3 50.09 27.39 49.73 27.39C49.62 27.39 49.53 27.38 49.46 27.37C49.32 26.86 49.26 25.49 50.24 24.35C51.31 23.12 52.87 22.51 53.94 22.21C53.94 22.21 53.94 22.21 53.94 22.21C53.59 24.03 53.05 25.35 52.34 26.17ZM49.49 23.7C47.93 25.5 48.35 27.81 48.76 28.17C48.9 28.3 49.26 28.39 49.73 28.39C50.66 28.39 52.05 28.03 53.1 26.83C55.14 24.47 55.02 20.96 55.02 20.96C55.02 20.96 55.02 20.96 55.02 20.96C52.69 21.21 50.85 22.13 49.49 23.7Z",
    id: "b17UGbOjMf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.01 47.59C42.61 47.87 43.94 48.9 44.74 49.67C43.94 50.02 42.76 50.4 41.51 50.4C41.16 50.4 40.83 50.37 40.51 50.31C39.03 50.05 38.22 48.94 38.01 48.46C38.32 48.14 39.19 47.53 40.38 47.53C40.38 47.53 40.38 47.53 40.38 47.53C40.66 47.54 40.87 47.56 41.01 47.59ZM36.97 48.27C36.87 48.81 37.99 50.88 40.34 51.3C40.73 51.37 41.12 51.4 41.51 51.4C44.12 51.4 46.36 49.96 46.36 49.96C46.36 49.96 44.26 47.15 41.18 46.6C40.91 46.55 40.64 46.53 40.38 46.53C40.38 46.53 40.38 46.53 40.38 46.53C38.16 47.37 37.03 47.95 36.97 48.27Z",
    id: "bKacctC9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1 17.76C49.53 19.16 48.29 19.72 47.76 19.82C47.46 19.38 46.96 18.11 47.53 16.71C48.15 15.21 49.43 14.12 50.35 13.49C50.35 13.49 50.35 13.49 50.35 13.49C50.6 15.33 50.51 16.75 50.1 17.76ZM46.61 16.33C45.71 18.54 46.85 20.6 47.36 20.81C47.42 20.83 47.5 20.84 47.6 20.84C48.37 20.84 50.23 20.1 51.03 18.14C52.21 15.25 50.97 11.97 50.97 11.97C50.97 11.97 50.97 11.97 50.97 11.97C48.85 12.95 47.4 14.41 46.61 16.33Z",
    id: "c10KRdZfA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.61 22.42L30.63 22.45L36.5 23.31L32.25 27.45L33.25 33.3L28 30.53L22.75 33.3L23.75 27.45L19.5 23.31L25.37 22.45L28 17.13L28 17.13L30.61 22.42ZM27.1 16.69L24.71 21.54L19.36 22.32L17.35 22.61L18.8 24.02L22.68 27.8L21.76 33.13L21.42 35.12L23.21 34.18L28 31.66L32.78 34.18L34.58 35.12L34.24 33.13L33.32 27.8L37.2 24.02L38.65 22.61L36.64 22.32L31.29 21.54L28.9 16.69L28 14.88L28 14.88L27.1 16.69Z",
    id: "aKwrFZArR"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bp6CyIh8O",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bp6CyIh8O",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1t6uPoYZp",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1t6uPoYZp",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1HpNsIBlr",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1HpNsIBlr",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c8QogCGmx",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c8QogCGmx",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aWxmOQu9S",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aWxmOQu9S",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d5CI84F09G",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d5CI84F09G",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1KSmX5ANM",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1KSmX5ANM",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4bZct5Az",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4bZct5Az",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1jb0U2SW9",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1jb0U2SW9",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1INFPZBV",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1INFPZBV",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b32yhIGDwF",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b32yhIGDwF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2EWHgLUjo",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2EWHgLUjo",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bwouNWDPb",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bwouNWDPb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1R6To3G2P",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1R6To3G2P",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d3g3U5zcE0",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d3g3U5zcE0",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2VQuQsrXC",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2VQuQsrXC",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ajw7r3pRZ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ajw7r3pRZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1yhz4Alp9",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1yhz4Alp9",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aG0eA6I85",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aG0eA6I85",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#amLRMYUvB",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#amLRMYUvB",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cc9rhfnp4",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cc9rhfnp4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2vhuE3Ur",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2vhuE3Ur",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1sSjBZwo6",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1sSjBZwo6",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dtSmeDUrz",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dtSmeDUrz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2gHgwKXbZ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2gHgwKXbZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1477dlS4K",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1477dlS4K",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j229IrWkF",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j229IrWkF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b17UGbOjMf",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b17UGbOjMf",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bKacctC9Z",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bKacctC9Z",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c10KRdZfA4",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c10KRdZfA4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aKwrFZArR",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aKwrFZArR",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness1);
export default __webpack_public_path__ + "static/media/business-1.bff24586cd1a1285e2fe6e4327f98876.svg";
export { ForwardRef as ReactComponent };